import React, { FC, PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { TitleText } from './StyledComponents';
import { FlexGroup, FlexItem } from '@lithos';

interface GraphContainerProps {
  headerLabel: string;
}

export const X_AXIS_LABEL = 'Time (Local)';
const ChartContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const GraphContainer: FC<PropsWithChildren<GraphContainerProps>> = ({ headerLabel, children }) => {
  return (
    <FlexGroup gapSize="4" padding="0" direction="column">
      <FlexItem>
        <TitleText>{headerLabel}</TitleText>
      </FlexItem>
      <FlexItem>
        <ChartContainer>{children}</ChartContainer>
      </FlexItem>
    </FlexGroup>
  );
};

export default GraphContainer;
